import type { CalendarEvent } from 'owa-calendar-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isValidSmtpAddress } from 'owa-recipient-email-address/lib/utils/isValidRecipientAddress';

export function shouldQueryCollabObject(
    event: CalendarEvent,
    isMeetingRecapScenario?: boolean
): boolean {
    if (!event) {
        return false;
    }

    const flightCheck =
        isFeatureEnabled('cal-meeting-recap') || isFeatureEnabled('cal-fluid-collabObject');

    return (
        flightCheck &&
        !!event.UID &&
        isValidSmtpAddress(event.Organizer?.Mailbox?.EmailAddress) &&
        isValidSmtpAddress(event.ItemId?.mailboxInfo?.userIdentity)
    );
}
